import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { ReactComponent as ZixxarLogo } from "../../Assets/Global/zixxar-logo.svg";
import { ReactComponent as CryptodataLogo } from "../../Assets/Footer/cryptodata-logo.svg";
import termsPDF from "../../Assets/Documents/conditions.pdf";
import privacyPDF from "../../Assets/Documents/privacy.pdf";
import { socialMediaIcons } from "./icons";

const renderSocialIcons = () => {
  const icons = socialMediaIcons.map(icon => (
    <a
      key={icon.id}
      href={icon.href}
      target="_blank"
      rel="noreferrer"
      className={`${icon.last ? "" : "me-4"} link-icon`}
    >
      {icon.icon}
    </a>
  ));
  return icons;
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="large-container">
        <p className="footer-info font-pnr line-height-1-7">
          1. Zixxar is a direct selling company that markets its products through independent Affiliates. It is
          important to understand that each Affiliate's success depends on the integrity of the people who market
          Zixxar's products and services. The agreement is made to clearly define the relationship between Zixxar and
          its independent Affiliates
        </p>
        <p className="footer-info font-pnr line-height-1-7">
          2. The Operational Rules identify and establish rules to maintain and develop Zixxar's business system and the
          rights, obligations and responsibilities of each Affiliate. Affiliates must comply with the Operational Rules.
          Zixxar has reserved the right to modify any of the terms of the policies and procedures set forth below, at
          any time at the Company's discretion after registration, and such modifications shall be valid and binding
          upon notification. These amendments will be updated in the revised Operational Rules and widely announced to
          Affiliates through one or more appropriate forms from time to time: additional trainings, announcements via
          the websites, public listings at the head office, branches, representative offices or business locations of
          the Company
        </p>

        <div className="w-100 mt-5 pt-5 d-flex justify-content-center">
          <div className="lang-col"></div>

          <div className="icons-wrapper">{renderSocialIcons()}</div>

          <div className="links-wrapper-col">
            <div className="links-container">
              <div className="link-col justify-content-end">
                <a
                  href={termsPDF}
                  target="_blank"
                  rel="noreferrer"
                  className="footer-links color-light-grey font-pnr font-size-18"
                >
                  Terms of service
                </a>
              </div>
              <div className="link-col">
                <Link to="/">
                  <ZixxarLogo />
                </Link>
                <a
                  href="https://beta.zixxar.net"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-links color-light-grey font-pnr font-size-18"
                >
                  Sign up
                </a>

                {/* mobile links start */}
                <a
                  href={termsPDF}
                  target="_blank"
                  rel="noreferrer"
                  className="footer-links color-light-grey font-pnr font-size-18 terms-link-mobile"
                >
                  Terms of service
                </a>

                <a
                  href={privacyPDF}
                  target="_blank"
                  rel="noreferrer"
                  className="footer-links color-light-grey font-pnr font-size-18 terms-link-mobile"
                >
                  Privacy Policy
                </a>
                {/* mobile links end */}
              </div>
              <div className="link-col justify-content-end">
                <a
                  href={privacyPDF}
                  target="_blank"
                  rel="noreferrer"
                  className="footer-links color-light-grey font-pnr font-size-18"
                >
                  Privacy Policy
                </a>
              </div>
            </div>

            <div className="social-icons-mobile">{renderSocialIcons()}</div>
          </div>

          <div className="logo-col">
            <div className="d-flex align-items-center">
              <span className="color-light-grey font-size-18 font-pnr text-break">
                Developed by
                <a href="https://cryptodata.com/" target="_blank" rel="noreferrer">
                  <CryptodataLogo className="ms-2" />
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className="dev-container-small">
          <span className="color-light-grey font-size-18 font-pnr text-break">
            Developed by
            <CryptodataLogo className="ms-2 cryptodata-logo-mobile" />
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
